<template>
  <Modal
    v-model="_value"
    width="500"
    title='短信RM设置终端信息'
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">

    <Form :label-width="110">
      <FormItem prop="sms" label="省域ID">
        <Input v-model="provincialID" placeholder="省域ID" style="width: 220px;">
        </Input>
      </FormItem>
      <FormItem prop="sms" label="制造商ID">
        <Input v-model="manufacturerID" placeholder="制造商ID" style="width: 220px;">
        </Input>
      </FormItem>
      <FormItem prop="sms" label="终端型号">
        <Input v-model="terminalType" placeholder="终端型号" style="width: 220px;">
        </Input>
      </FormItem>
    </Form>

  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'setuprmstifsmsmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      businessUserId: null,
    },
    data() {
      return {
        simNum:null,

        provincialID:null,
        manufacturerID:null,
        terminalType:null,
      }
    },
    methods: {
      ...mapActions([
        'ShortMessageServ_Send'
      ]),
      onOk() {
        if (!this.provincialID || this.provincialID === '') {
          this.$Message.error('请填写省域ID')
          return
        }
        if (!this.manufacturerID || this.manufacturerID === '') {
          this.$Message.error('请填写制造商ID')
          return
        }
        if (!this.terminalType || this.terminalType === '') {
          this.$Message.error('请填写终端型号')
          return
        }
        //共三条短信，对应不同密码
        // console.log(this.simNum.substring(6))

          this.sendSMS('99admin,admin,STIF'+this.provincialID+','+this.manufacturerID+','+this.terminalType+'! ')

          setTimeout(() => {
              this.sendSMS('99admin,JC336699,STIF'+this.provincialID+','+this.manufacturerID+','+this.terminalType+'! ')
            }
            ,1000)

          setTimeout(() => {
              this.sendSMS('99admin,,STIF'+this.provincialID+','+this.manufacturerID+','+this.terminalType+'! ')
            }
            ,2000)

        setTimeout(() => {
            this.sendSMS('99admin,JcBOZSJCB0,STIF'+this.provincialID+','+this.manufacturerID+','+this.terminalType+'! ')
          }
          ,3000)

      },
      sendSMS (content) {
        if (!this.simNum || this.simNum === '') {
          this.$Message.error('请选择SIM卡号')
          return
        }
        store.dispatch('ShortMessageServ_Send', { params: { simNum: this.simNum, content: content } }).then(() => {
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if(val){
          this.simNum = this._initValue
          this.provincialID = 44
          this.manufacturerID = 70504
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _businessUserId:{
        get() {
          return this.businessUserId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
          phoneNum: this.phoneNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
